import { RECAPTCHA_PUBLIC_KEY } from "../configs/recaptchaConfig";
import * as Sentry from "@sentry/react";

const useRecaptcha = () => {
  const executeRecaptcha = async (action) => {
    try {
      if (!window.grecaptcha) {
        return "";
      }

      return await new Promise((resolve) => {
        window.grecaptcha.ready(async () => {
          try {
            const token = await window.grecaptcha.execute(
              RECAPTCHA_PUBLIC_KEY,
              { action },
            );
            resolve(token);
          } catch (error) {
            Sentry.captureException(error, {
              tags: {
                source: "recaptcha",
                action,
              },
              level: "warning",
            });
            resolve("");
          }
        });
      });
    } catch (error) {
      Sentry.captureException(error, {
        tags: {
          source: "recaptcha_outer",
          action,
        },
      });
      return "";
    }
  };

  return { executeRecaptcha };
};

export default useRecaptcha;
